/**
 * Builds a URL query string from an object of parameters
 * @param params - Object with query parameters
 * @returns URL-encoded query string
 */

// biome-ignore lint/suspicious/noExplicitAny: generic params require any type
export function buildQueryString(params: Record<string, any>): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
}
